// Prototype's raw <button> markup relied on a global `button{border:none;background:none;...}`
// reset (its own index.html <style>) that this app doesn't have. Spread this first in any
// class applied to a plain <button> so native browser chrome (default border/grey face) doesn't
// leak through — set explicit background/border afterward when the design calls for one.
export const BTN_RESET = {
  border: "none",
  background: "none",
  cursor: "pointer",
  font: "inherit",
  textAlign: "left",
  color: "inherit",
};

// Design tokens lifted from the va-quarterly-design.html prototype (purple Skypoint theme).
export const QR = {
  bg: "#F5F5F5",
  surface: "#FFF",
  surfaceSoft: "#FAFAFA",
  surfaceAlt: "#F4F4F5",
  tableHeadBg: "#F2F2F2",
  line: "#E5E5E5",
  lineSoft: "#F3F4F6",
  ink: "#171717",
  ink2: "#262626",
  muted: "#667085",
  muted2: "#9CA3AF",

  purple: "#53389E",
  purpleDeep: "#43307E",
  purpleSoft: "#F3F0FB",
  purpleRing: "#DDD6FE",

  accent: "#FFAF4A",
  accentSoft: "#FFF6E9",
  accentHover: "#F09E33",
  accentRing: "#FFE0B0",

  success: "#16A34A",
  successSoft: "#F0FDF4",
  successDeep: "#15803D",

  danger: "#DC2626",
  dangerSoft: "#FEF2F2",
  dangerDeep: "#B91C1C",

  info: "#2563EB",
  infoSoft: "#EFF6FF",
  infoDeep: "#1D4ED8",

  shadowCard: "0 1px 2px rgba(16,24,40,.04)",
};

// Skai/Tara Ai panel uses its own distinct purple-violet language per the prototype.
export const TARA = {
  accent: "#7856FF",
  bg: "#FAF5FF",
  ink: "#2E1065",
  ink2: "#5B21B6",
  ink3: "#6D28D9",
  ink4: "#8B5CF6",
  border: "#DDD6FE",
  borderSoft: "#EDE9FE",
  borderStrong: "#C4B5FD",
};

// Persisted list statuses (Story 1: only these two ever appear in the main list/filter).
export const REPORT_STATUS = {
  draft: { label: "Awaiting Review", bg: QR.infoSoft, color: QR.infoDeep, border: "#BFDBFE" },
  final: { label: "Final", bg: QR.successSoft, color: QR.successDeep, border: "#BBF7D0" },
};

// How a report was produced. 'manual' reports are hand-entered for a provider
// that documents in its own EHR — no AI is involved at any point.
export const REPORT_SOURCE = {
  ai: { label: "Tara Ai", bg: QR.infoSoft, color: QR.infoDeep, border: "#BFDBFE" },
  manual: { label: "Manual", bg: QR.surfaceAlt, color: QR.ink2, border: QR.line },
};

// Past Due / Failed page pill.
export const WORKLIST_STATUS = {
  overdue: { label: "Past due", bg: QR.dangerSoft, color: QR.dangerDeep, border: "#FECACA" },
};

// Transient per-client generation progress state (never persisted as a list status).
export const PROGRESS_STATUS = {
  ready: { label: "Ready for review", chipBg: QR.successSoft, chipColor: QR.successDeep, chipBorder: "#BBF7D0" },
  generating: { label: "Generating", chipBg: QR.accentSoft, chipColor: "#B45309", chipBorder: QR.accentRing },
  waiting: { label: "Waiting", chipBg: QR.surfaceAlt, chipColor: QR.muted2, chipBorder: QR.line },
  failed: { label: "Failed", chipBg: QR.dangerSoft, chipColor: QR.dangerDeep, chipBorder: "#FECACA" },
};
